import React from 'react'

import { Spacings } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const NextStepSpacer: React.CSSProperties = {
  height: toPx(Spacings.NODE_HORIZONTAL_PADDING),
}
